import React, { useState } from 'react';

import { DeviceIdentity } from './DeviceIdentity';
import { ShippingBadge } from './ShippingBadge';

interface DeviceCardProps {
  device: {
    sku: string;
    name: string;
    manufacturer: string;
    series: DeviceSeries;
    imageUrl?: string;
    shippingProvider: string;
    extendedRange?: boolean;
  };
  isSelected: boolean;
  onToggle: () => void;
  footer?: React.ReactNode;
  expandedContent?: React.ReactNode;
  disabled?: boolean;
}

export const DeviceCard = ({
  device,
  isSelected,
  onToggle,
  footer,
  expandedContent,
  disabled
}: DeviceCardProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const borderColor = isHovered && !isSelected && !disabled ? '#ced4da' : '#dee2e6';

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-pressed={isSelected}
      onClick={disabled ? undefined : onToggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`d-flex flex-column rounded-3 p-3 device-card device-card-${device.series}`}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
          e.preventDefault();
          onToggle();
        }
      }}
      style={
        {
          '--device-border-color': borderColor,
          backgroundColor: isSelected ? '#E6F1FB' : 'white',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.45 : 1
        } as React.CSSProperties
      }
      data-test={`device-card-${device.sku}`}
    >
      <div className="d-flex align-items-start justify-content-between gap-2">
        {/* Shared with the read-only price list on Rates & Pricing, so the two cannot drift. */}
        <DeviceIdentity device={device} />

        <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
          <ShippingBadge shippingProvider={device.shippingProvider} />
          {footer}
        </div>
      </div>

      {expandedContent && <div className="mt-2">{expandedContent}</div>}
    </div>
  );
};
